import { render, staticRenderFns } from "./09_obtaining.vue?vue&type=template&id=d2305b32"
import script from "./09_obtaining.vue?vue&type=script&lang=js"
export * from "./09_obtaining.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports